import React, { useRef } from 'react'
import SlidingPane from "react-sliding-pane";
import Tooltip from "@tippyjs/react";
import "react-toastify/dist/ReactToastify.css";
import "tippy.js/dist/tippy.css";
import Form from "react-validation/build/form";
import CheckButton from "react-validation/build/button";
import { getTrans as t } from "../../../Localization/translations";
const AddCutomer = ({state1,setState1,handleSubmit2,handlepartydefault,form2,party_type,setParty_type,customer_type,register2,handleshowhide,errors2,customer_name,setCustomer_name,address_line_1,
    setAddress_line_1,countryid,country_name,handlecountry,stateaddressId,state_name,handlestate, city,setCity,zip_code,setZip_code,checkBtn2,setAddress_line_2,address_line_2
}) => {

    return (
        <SlidingPane
            className="some-custom-class sidepanebar"
            isOpen={state1.isPaneOpen}
            title="Add Customer"
            subtitle=""
            onRequestClose={() => {
                setState1({ isPaneOpen: false });
            }}
        >
            <Form
                role="form text-left"
                onSubmit={handleSubmit2(handlepartydefault)}
                ref={form2}
                key={2}
                action="."
                method="POST"
                id="addReceiptForm"
            >
                {
                    <>
                        <div className="row">
                            <div className="col-md-6">
                                <label className="col-form-label required">
                                    {t("Party Type")}{" "}
                                    <Tooltip content={t("PartyType_Tooltip")}>
                                        <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                </label>
                                <div className="form-group row">
                                    <div
                                        className="form-check"
                                        style={{ width: "25%", paddingLeft: "3.0em" }}
                                    >
                                        <input
                                            className="form-check-input"
                                            checked={party_type === "Customer" ? true : false}
                                            value="Customer"
                                            type="radio"
                                            name="vendor"
                                            id="flexRadioDefault2"
                                            onChange={(e) => setParty_type(e.target.value)}
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="flexRadioDefault2"
                                        >
                                            Customer
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <label className="col-form-label required">
                                {t("Entity Type")}{" "}
                                <Tooltip content={t("EntityType_Tooltip")}>
                                    <i className="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                            </label>
                            <div className="form-group row">
                                <div
                                    className="form-check"
                                    style={{ width: "25%", paddingLeft: "2.73em" }}
                                >
                                    <input
                                        className="form-check-input"
                                        checked={customer_type === "Person" ? true : false}
                                        value="Person"
                                        type="radio"
                                        name="person"
                                        id="id_customer_type"
                                        {...register2("customer_type", {
                                            onChange: (e) => {
                                                handleshowhide(e);
                                            },
                                            required: true,
                                        })}
                                    />
                                    <label
                                        className="form-check-label"
                                        htmlFor="flexRadioDefault1"
                                    >
                                        Person
                                    </label>
                                </div>
                                <div
                                    className="form-check"
                                    style={{ width: "25%", paddingLeft: "4.73em" }}
                                >
                                    <input
                                        className="form-check-input"
                                        checked={
                                            customer_type === "Organization" ? true : false
                                        }
                                        value="Organization"
                                        type="radio"
                                        name="organization"
                                        id="id_customer_type"
                                        {...register2("customer_type", {
                                            onChange: (e) => {
                                                handleshowhide(e);
                                            },
                                            required: true,
                                        })}
                                    />
                                    <label
                                        className="form-check-label"
                                        htmlFor="flexRadioDefault1"
                                    >
                                        Organization
                                    </label>
                                </div>
                            </div>
                            <div className="invalid-feedback">
                                {errors2.customer_type?.type === "required" &&
                                    "Entity Type  is required"}
                            </div>
                        </div>
                        <div className="form-group row">
                            <div className="col-md-12">
                                <label className="col-form-label required">
                                    {t("Party Name")}{" "}
                                    <Tooltip content={t("PartyName_Tooltip")}>
                                        <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                </label>
                                <input
                                    placeholder={t("Party Name")}
                                    className="form-control"
                                    type="text"
                                    value={customer_name}
                                    name="customer_name"
                                    maxLength="200"
                                    id="id_customer_name"
                                    {...register2("customer_name", {
                                        onChange: (e) => {
                                            setCustomer_name(e.target.value);
                                        },
                                        required: true,
                                    })}
                                />
                                <div className="invalid-feedback">
                                    {errors2.customer_name?.type === "required" &&
                                        "Party Name  is required"}
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-md-6">
                                    <label className="col-form-label required">
                                        {t("Address Line 1")}{" "}
                                        <Tooltip content={t("Address_Tooltip")}>
                                            <i className="fa fa-light fa-circle-info"></i>
                                        </Tooltip>
                                    </label>
                                    <input
                                        placeholder={t("Address Line 1")}
                                        className="form-control"
                                        type="text"
                                        name="address_line_1"
                                        maxLength="200"
                                        id="id_address_line_1"
                                        value={address_line_1}
                                        {...register2("address_line_1", {
                                            onChange: (e) => {
                                                setAddress_line_1(e.target.value);
                                            },
                                            required: true,
                                        })}
                                    />
                                    <div className="invalid-feedback">
                                        {errors2.address_line_1?.type === "required" &&
                                            "Address is required"}
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <label className="col-form-label">
                                        {t("Address Line 2")}{" "}
                                        <Tooltip content={t("Address2_Tooltip")}>
                                            <i className="fa fa-light fa-circle-info"></i>
                                        </Tooltip>
                                    </label>
                                    <input
                                        placeholder={t("Address Line 2")}
                                        className="form-control"
                                        type="text"
                                        onChange={(e) => setAddress_line_2(e.target.value)}
                                        name="address_line_2"
                                        maxLength="200"
                                        id="id_address_line_2"
                                        value={address_line_2}
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-md-6">
                                    <label className="col-form-label required">
                                        {t("Country")}{" "}
                                        <Tooltip content={t("Country_Tooltip")}>
                                            <i className="fa fa-light fa-circle-info"></i>
                                        </Tooltip>
                                    </label>
                                    <select
                                        type="text"
                                        className="form-control"
                                        value={countryid}
                                        name="country"
                                        id="id_country"
                                        {...register2("country", { onChange: (e) => { handlecountry(e) }, required: true })}
                                    >
                                        <option value="">---{t("Select Country")}---</option>
                                        {
                                            country_name.map((country, i) =>
                                            (
                                                <option key={i} value={country.id} >{country.name}</option>
                                            ))
                                        }
                                    </select>
                                    <div className="invalid-feedback">
                                        {errors2.country?.type === "required" &&
                                            "Country is required"}
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <label className="col-form-label required">
                                        {t("State")}{" "}
                                        <Tooltip content={t("State_Tooltip")}>
                                            <i className="fa fa-light fa-circle-info"></i>
                                        </Tooltip>
                                    </label>
                                    <select
                                        value={stateaddressId}
                                        className="form-control"
                                        name="state"
                                        {...register2("state", { onChange: (e) => { handlestate(e) }, required: true })}
                                    >
                                        <option value="">---{t("Select State")}---</option>
                                        {
                                            state_name.map((resst, i) => (
                                                <option key={i} value={resst.id} >{resst.name}</option>
                                            ))
                                        }
                                    </select>
                                    <div className="invalid-feedback">
                                        {errors2.state?.type === "required" &&
                                            "State is required"}
                                    </div>
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-md-6">
                                    <label className="col-form-label required">
                                        {t("City")}{" "}
                                        <Tooltip content={t("City_Tooltip")}>
                                            <i className="fa fa-light fa-circle-info"></i>
                                        </Tooltip>
                                    </label>
                                    <input
                                        placeholder={t("City")}
                                        className="form-control"
                                        type="text"
                                        name="city"
                                        maxLength="100"
                                        id="id_city"
                                        value={city}
                                        {...register2("city", {
                                            onChange: (e) => {
                                                setCity(e.target.value);
                                            },
                                            required: true,
                                        })}
                                    />
                                    <div className="invalid-feedback">
                                        {errors2.city?.type === "required" &&
                                            "City is required"}
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <label className="col-form-label required">
                                        {t("Zip Code")}{" "}
                                        <Tooltip content={t("ZipCode_Tooltip")}>
                                            <i className="fa fa-light fa-circle-info"></i>
                                        </Tooltip>
                                    </label>
                                    <input
                                        placeholder={t("Zip Code")}
                                        className="form-control"
                                        type="text"
                                        name="zip_code"
                                        maxLength="30"
                                        id="id_zip_code"
                                        value={zip_code}
                                        {...register2("zip_code", {
                                            onChange: (e) => {
                                                setZip_code(e.target.value);
                                            },
                                            required: true,
                                        })}
                                    />
                                    <div className="invalid-feedback">
                                        {errors2.zip_code?.type === "required" &&
                                            "Zip Code is required"}
                                    </div>
                                </div>

                            </div>
                        </div>
                        <button
                            type="submit"
                            className="border-0 btn btn-primary btn-gradient-primary btn-md"
                        >
                            {t("Save")}
                        </button>
                        &nbsp;&nbsp;
                    </>
                }
                <CheckButton style={{ display: "none" }} ref={checkBtn2} />
            </Form>
        </SlidingPane>
    )
}

export default AddCutomer